import React from "react";
import SuccessCheck from "animations/SuccessCheck";
import { CircularProgress } from "@material-ui/core";

//import PropTypes from 'prop-types';

export function StatusImage({ status, size }) {
    if (status === "success") return <SuccessCheck size={size} />;
    return <CircularProgress size={size} />;
}

StatusImage.propTypes = {};

StatusImage.defaultProps = {};

export default StatusImage;
